import type { Locale } from '$lib/i18n/types';

export function matchGuardByLocaleAndDates(startDate: string, endDate: string, locale: Locale, enabledLocale: Locale) {
	if (!startDate || !endDate) {
		return false;
	}

	const currentDate = new Date();
	return locale === enabledLocale && currentDate > new Date(startDate) && currentDate < new Date(endDate);
}
